// extracted by mini-css-extract-plugin
module.exports = {"BooleanFeature":"vy_a bhj_b"};